import { FC, ReactElement } from 'react';
import { isITAREnvironment } from 'constants/env';
import { useWorkspaceQuery } from 'modules/workspace/workspaceApi';
import Header from '../modules/header/Header';
import { CuiFooter, CuiHeaderBanner } from './CuiBanners';

interface IProps {
  children: ReactElement;
}

const WithHeader: FC<IProps> = ({ children }) => {
  const { data: workspace } = useWorkspaceQuery();
  const showCuiBanners = workspace?.isCui === true;

  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      {showCuiBanners && <CuiHeaderBanner />}
      <Header upgradingEnabled={!isITAREnvironment()} />
      <main className="min-h-0 flex-1 overflow-auto">
        <div
          className={`mx-auto w-full px-4 py-3 md:px-6 md:py-4
            lg:max-w-[1600px] lg:px-4 xl:max-w-[1920px]`}
        >
          {children}
        </div>
      </main>
      {showCuiBanners && <CuiFooter />}
    </div>
  );
};

export default WithHeader;
